import { AreaApi } from "../../../../Shared/Constants/api";
import axiosInstance from "../../../../Shared/Utils/axiosInstance";

export const deleteAreaApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${AreaApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
